/**
 * Math Functions for calculating various length and angles
 * Ported from Java to TypeScript
 */

export class MathFunctions {
  /**
   * Calculates the length of side B given
   * Using law of sins
   *
   * @param lengthA length of side A
   * @param angleA angle across from side A
   * @param angleB angle across form side B
   * @return length of side B
   */
  static calcLength(lengthA: number, angleA: number, angleB: number): number {
    const sinA = Math.sin(angleA * Math.PI / 180);
    const sinB = Math.sin(angleB * Math.PI / 180);
    
    const lengthB = (lengthA / sinA) * sinB;
    
    return Math.round(lengthB * 100) / 100;
  }

  /**
   * Calculate the radius using formula (4y^2+x^2)/8y
   *
   * @param length length of line across radius
   * @param height height from center of line to radius
   * @return the radius
   */
  static calcRad(length: number, height: number): number {
    const x = length;
    const y = height;
    
    const r = ((4 * Math.pow(y, 2)) + Math.pow(x, 2)) / (8 * y);
    
    return Math.round(r * 100) / 100;
  }

  /**
   * Calculate the length of radius
   *
   * @param radius radius of arc
   * @param angle angle of arc segment
   * @return the angle
   */
  static calcRadLength(radius: number, angle: number): number {
    const length = (Math.PI * radius / 180) * angle;
    
    return Math.round(length * 100) / 100;
  }

  /**
   * Calculate the angle using law of Cosines
   *
   * @param length length of line across radius
   * @param radius radius of arc
   * @return angle
   */
  static calcAngle(length: number, radius: number): number {
    const a = length;
    const b = radius;
    const c = b;
    
    const cosA = (Math.pow(b, 2) + Math.pow(c, 2) - Math.pow(a, 2)) / (2 * b * c);
    const angle = Math.acos(cosA) * 180 / Math.PI;
    
    return Math.round(angle * 100) / 100;
  }
}